export const toFullName = (data: {
  first_name: string;
  last_name: string;
}): string => `${data.last_name}, ${data.first_name}`;
